export const invite = {
  fuwutiaokuan: '《服務條款》',
  yinsizhengce: '《隱私政策》',
  fzcg: '複製成功',
  yqhy: "邀請好友",
  fxlj: "分享連結",
  register_now: '立即注册',
  phone: '手機',
  email: '郵箱',
  placehold_phone: '請輸入您的手機號碼',
  placehold_email: '請輸入您的郵箱',
  placehold_code: '邀請碼',
  argee: '我已閱讀並同意',
  agreement: '《BiKing用戶協議》',
  register: '注册',
  phone_code: '簡訊驗證碼',
  email_code: '郵箱驗證碼',
  code_to_phone: '驗證碼已經以簡訊的形式發送到您的手機上',
  code_to_email: '驗證碼已經以郵箱的形式發送到您的郵箱上',
  has_sent: '已發送驗證碼至：',
  resend: '重新發送',
  send_code: '發送驗證碼',
  unable_code: '無法收到驗證碼？',
  set_pwd: '設置密碼',
  placehold_pwd: '請輸入您的密碼',
  submit: '提交',
  error_phone: '請輸入正確的手機號碼',
  error_email: '郵箱格式不正確，請重新輸入',
  error_checked: '請先確認勾選協定',
  text: '密碼格式錯誤，密碼必須是8-32比特，同時包含大小寫字母和數位。',
  validate: '請完成驗證',
  register_success: '注册成功！',
  welcome: '幣王歡迎您',
  start_trade: '充值加密貨幣開始交易',
  safe: '多種充值管道，安全、便捷交易加密貨幣',
  pay_type: '通過銀行卡或其他支付方式買賣加密貨幣',
  right_now_download: '立即前往下載',
  right_download: '前往下载',
  'Please_enter_correct_phone_number':'請輸入正確的手機號碼',
  'Referral_code':'請輸入您的邀請碼',
  'I_have_read_and_agree':'我已閱讀並同意',
  'BiKing_User_Agreement':'《BiKing用戶協議》',
  'Please_enter_password':'請輸入您的密碼',
  'Email_verification_code':'郵箱驗證碼',
  'SMS_code':'短信驗證碼',
  'Incorrect_email_format_please_reenter':'郵箱格式不正確,請重新輸入',
  'Please_read_and_agree_User_Agreement':'請閱讀並同意用戶協議',
  'Sent_code_to':'已发送驗證碼到',
  zjff: '直接發放！',
  ycxdz: '一次性到賬！',
  bbsy: '0成本博百倍收益！',
  sdly: '選擇幣王交易的三大理由',
  aqfktx: '世界頂尖安全風控體系',
  aqhg: '安全合規 可信賴的價值網絡 專業分佈式架構和防 DDOS 攻擊系統',
  qqbthyytd: '全球本土化運營團隊',
  qqbj: '全球佈局 多個國家本土服務 打造多業務形態區塊鏈生態圈',
  fwtx: '重塑以用戶為本服務體系',
  yhzs: '用戶至上 獨創先行賠付機制 設立用戶保護基金',
  jslc: '解鎖流程',
  zcwcjkjs: '註冊完成後，1188USDT以贈金賬戶餘額形式發放，進入贈金賬戶即可解鎖。',
  czts: '操作示例：您在成功註冊後將領取到的1000USDT購買20倍槓桿BTC多單，當BTC上漲1%時，您即獲得20%收益，即200USDT，該收益可直接提現。',
  zhu: '注：',
  qzlqyky: '1188USDT單筆分批發放及領取，全種類合約可用',
  gqql: '1188USDT使用期1個月，過期清零',
}


// WEBPACK FOOTER //
// ./src/i18n/lang/invite/tw.js